import { render } from "./AddSubscription.vue?vue&type=template&id=08abc40b&ts=true"
import script from "./AddSubscription.vue?vue&type=script&lang=ts"
export * from "./AddSubscription.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/kemet/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__